import UserModel from "@/models/UserModel";

export default class AuthorizationState {
  loaded = false;
  isLoggedIn = false;
  currentUser?: UserModel;
}
